const ROOT = '/';
const LOGIN = '/login';
const PROJECTS = '/projects/:id';
const BOARDS = '/boards/:id';
const CARDS = '/cards/:id';

export default {
  ROOT,
  LOGIN,
  PROJECTS,
  BOARDS,
  CARDS,
};
